import { h, render } from 'preact'
import App from './App.jsx'
import './styles/main.css'
import './styles/slider.css'
import './styles/scroll.css'

render(<App />, document.getElementById('app'))
